/*
 * File: summary.ts
 * Project: meki
 * File Created: Thursday, 11th November 2021 10:55:35 am
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 1st December 2023 11:26:34 am
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { gql } from '@apollo/client';
import { ResolverParams } from '@queries/queries.interfaces';
import { PaymentMethod, User, Order } from '@interfaces';

export const getCheckoutPaymentMethod = () => gql`
  query getCheckoutPaymentMethod($params: CurrentOrderParams) {
    currentOrder(params: $params) {
      id
      uuid
      orderGroupId
      deliveryCost
      metadata {
        useMekiCredits
        installments
        payments {
          amount
          type
        }
        userInfo {
          email
          name
          rut
        }
        sendEmail
        insuranceInfo {
          insuranceId
          totalReimbursement
          totalDeductible
          reimbursedProducts {
            sku
            observation
            unitReimbursement
            unitCopay
            unitDeductible
            coverage
          }
        }
        localVendor {
          paymentMethod
          mixPayments
        }
        assistantVendor {
          paymentMethod
        }
        chargeDeliveryCost
      }
      paymentMethod {
        id
        uuid
        type
        data
      }
      address {
        id
        name
        street
        streetNumber
        commune
      }
    }
    paymentMethods {
      id
      uuid
      type
      data
    }
    currentUserInfo {
      credits
    }
  }
`;

export type GetCheckoutPaymentMethodQueryResponse = {
  paymentMethods: PaymentMethod[];
  currentUserInfo: Pick<User, 'credits'>;
  currentOrder: Pick<
    Order,
    | 'id'
    | 'uuid'
    | 'orderGroupId'
    | 'address'
    | 'metadata'
    | 'paymentMethod'
    | 'deliveryCost'
  >;
};

export type GetCheckoutPaymentMethodQueryParams = ResolverParams<{
  orderUuid: string;
}>;
